// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"323163e1","453":"f78671cf","455":"bc6507c2","977":"caacd757"}[chunkId] + ".chunk.js";
};